import React from 'react'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'

import { useTranslationRankmi } from 'helpers/translations.helper'
import { ICourseModel } from 'models/course.model'
import { IMainState } from 'store/states'

import { Banner, BannerIcon, BannerText } from './styled'

interface NormativeCourseBannerProps {
  course: ICourseModel
}

type BannerVariant = 'missingAttestation' | 'incompleteProfile'

const NormativeCourseBanner: React.FC<NormativeCourseBannerProps> = ({
  course,
}) => {
  const attestationsEnabled = useSelector(
    ({ general }: IMainState) => general.permissions.attestationsEnabled
  )
  const t = useTranslationRankmi({
    prefix: 'components.courseCard.alerts',
  })

  if (!attestationsEnabled || !course.normative) {
    return null
  }

  let variant: BannerVariant | null = null

  if (course.dc3AttestationAssigned === false) {
    variant = 'missingAttestation'
  } else if (
    course.dc3AttestationAssigned === true &&
    course.normativeProfileIncomplete === true
  ) {
    variant = 'incompleteProfile'
  }

  if (!variant) {
    return null
  }

  return (
    <Banner>
      <BannerIcon>
        <FontAwesomeIcon icon={faTriangleExclamation} aria-hidden />
      </BannerIcon>
      <BannerText>
        <strong>{t(`${variant}.title`)}</strong> {t(`${variant}.body`)}
      </BannerText>
    </Banner>
  )
}

export default NormativeCourseBanner
